/* tslint:disable */
import {
  Product,
  ProductUom,
  StockQuant
} from '../index';

declare var Object: any;
export interface StockProductionLotInterface {
  "id"?: number;
  "name": string;
  "product_id"?: number;
  "product_uom_id"?: number;
  "quant_ids"?: Array<any>;
  product?: Product;
  productUom?: ProductUom;
  quants?: StockQuant[];
}

export class StockProductionLot implements StockProductionLotInterface {
  "id": number;
  "name": string;
  "product_id": number;
  "product_uom_id": number;
  "quant_ids": Array<any>;
  product: Product;
  productUom: ProductUom;
  quants: StockQuant[];
  constructor(data?: StockProductionLotInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockProductionLot`.
   */
  public static getModelName() {
    return "StockProductionLot";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockProductionLot for dynamic purposes.
  **/
  public static factory(data: StockProductionLotInterface): StockProductionLot{
    return new StockProductionLot(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockProductionLot',
      plural: 'StockProductionLots',
      path: 'StockProductionLots',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "product_uom_id": {
          name: 'product_uom_id',
          type: 'number'
        },
        "quant_ids": {
          name: 'quant_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
      },
      relations: {
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        productUom: {
          name: 'productUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_id',
          keyTo: 'id'
        },
        quants: {
          name: 'quants',
          type: 'StockQuant[]',
          model: 'StockQuant',
          relationType: 'referencesMany',
                  keyFrom: 'quant_ids',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockProductionLot.ts